<template>
  <button
    type="button"
    class="c-btn c-btn--eye"
    :class="{ 'is-visible': isVisible }"
    @click="click"
  >
    {{ isVisible ? '非表示' : '表示' }}
  </button>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    };
  },

  methods: {
    click(e) {
      this.isVisible = !this.isVisible;
      this.$emit('click', this.isVisible);
    }
  }
};
</script>
